import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const LinkBoxWrapper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),

  '& a': {
    display: 'block',
    cursor: 'pointer',
    padding: `${theme.spacing(0.5)} 0`,
    textDecoration: 'none',
    '&:before': {
      content: '""',
      display: 'inline-block',
      height: '0.555em',
      width: '0.555em',
      cursor: 'pointer',
      transform: 'rotate(-45deg)',
      marginRight: theme.spacing(2),
      borderColor: theme.palette.primary.main,
      borderStyle: 'solid',
      borderWidth: '0px 0.111em 0.111em 0px',
      borderImage: 'none 100% / 1 / 0 stretch',
      marginBottom: '0.111em',
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export interface LinkBoxContent {
  headline: string;
  links: { text: string; url: string }[];
}

export interface LinkBox {
  // Define the properties of LinkBox here
  linkBoxContent: LinkBoxContent;
}

export function LinkBox(props: LinkBox) {
  const { linkBoxContent } = props;
  const { headline, links } = linkBoxContent;

  return (
    <LinkBoxWrapper elevation={0}>
      <Typography
        variant="body1"
        sx={{
          mb: 2,
          fontWeight: 500,
        }}
      >
        {headline}
      </Typography>
      {links.map((linkItem, index) => (
        <Link href={linkItem.url} key={index}>
          {linkItem.text}
        </Link>
      ))}
    </LinkBoxWrapper>
  );
}
